<template>
  <div class="yzm-redpacket">
    <div class="yzm-redpacket__text">￥<span>{{ item.setting?.value }}</span></div>
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-redpacket {
  background: url('@/assets/images/card/red-packet.png');
  background-repeat: no-repeat;
  background-size: 100%;
  width: 164px;
  height: 103px;
  position: relative;
  padding-top: 6px;
  &__text {
    position: absolute;
    left:38%;
    top:8px;
    font-size: 14px;
    background-image: linear-gradient(to right, #fe8309, #f42507);
    -webkit-background-clip: text;
    color: transparent;
    >span{
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
